import * as Yup from 'yup';
import { UAE_COUNTRY_CODE } from '../constants/defaults';
import { partyTaxSchemeShape } from './partyTaxSchemeValidation';
import { partyIdentificationFields } from './partyIdentificationValidation';

export const SupplierValidation = (messages = {}) => {
  const m = messages || {};

  return Yup.object().shape(
    {
      name: Yup.string().required(m.name_required),
      party_name: Yup.string().required(m.business_name_required),
      party_name_in_local_language: Yup.string().nullable(),
      email: Yup.string().required(m.email_required).email(m.email_invalid).max(320, m.email_max),
      postal_address: Yup.object().shape({
        street_name: Yup.string().required(m.street_name_required),
        additional_street_name: Yup.string().nullable(),
        address_line: Yup.string().nullable(),
        city_name: Yup.string().required(m.city_name_required),
        country_subentity: Yup.mixed().when('country_code', ([country_code], schema) => {
          if (country_code?.code === UAE_COUNTRY_CODE) {
            return Yup.object()
              .shape({
                code: Yup.string().required(m.country_subentity_required_for_ae),
                name: Yup.string().required(),
              })
              .required(m.country_subentity_required_for_ae)
              .nullable();
          } else {
            return Yup.string().required(m.country_subentity_required);
          }
        }),
        country_code: Yup.object()
          .shape({
            code: Yup.string().required(m.country_required),
            label: Yup.string().required(),
          })
          .required(m.country_required),
        postal_zone: Yup.string().nullable().notRequired(),
      }),
      telephone: Yup.string().required(m.telephone_required),
      scheme_agency_id: Yup.mixed()
        .nullable()
        .when('company_id', ([companyId], schema) => {
          if (companyId != null && companyId !== '') {
            return Yup.object()
              .shape({
                code: Yup.string().required(m.registration_type_required),
                label: Yup.string().required(),
              })
              .required(m.registration_type_required);
          }

          return schema.nullable();
        }),
      company_id: Yup.string()
        .nullable()
        .when('scheme_agency_id', ([schemeAgencyId], schema) => {
          if (schemeAgencyId?.code != null && schemeAgencyId?.code !== '') {
            return schema.required(m.registration_number_required);
          }

          return schema.notRequired();
        }),
      authority_name: Yup.string()
        .nullable()
        .when('scheme_agency_id', {
          is: (val) => val?.code === 'TL',
          then: (schema) => schema.required(m.registration_authority_required_trade_license),
          otherwise: (schema) => schema.notRequired(),
        }),
      passport_issuing_country_code: Yup.mixed()
        .nullable()
        .when(['scheme_agency_id'], {
          is: (schemeAgencyId) => schemeAgencyId?.code === 'PAS',
          then: (schema) => schema.required(m.passport_issuing_country_required),
          otherwise: (schema) => schema.notRequired(),
        }),
      party_tax_scheme: Yup.object().when('postal_address.country_code', {
        is: (val) => val?.code === UAE_COUNTRY_CODE,
        then: (schema) => schema.shape(partyTaxSchemeShape(m)),
        otherwise: (schema) => schema.notRequired(),
      }),
      tin: Yup.string()
        .nullable()
        .when('postal_address.country_code', {
          is: (val) => val?.code === UAE_COUNTRY_CODE,
          then: (schema) => schema.required(m.TIN_required).trim().length(10, m.TIN_length).matches(/^1/, m.TIN_format),
        }),
      participant_id: Yup.string()
        .nullable()
        .test('participant-id-format', m.participant_id_format, (value) => {
          if (value === null || value === undefined || value === '') return true;
          return /^\d+:[A-Za-z0-9_.-]+$/.test(value);
        }),
      ...partyIdentificationFields(m),
      logo_url: Yup.string().nullable(),
    },
    [['scheme_agency_id', 'company_id']],
  );
};
